import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Principal } from '../../../../shared';
import { DatasetService } from '../../../../shared/dataset/service/dataset.service';
import { VariableTypeEnum } from '../../../../shared/ontology/variable-type.enum';
import { AlertService } from '../../../../shared/alert/alert.service';
import { ObservationVariable } from '../../../../shared/model/observation-variable.model';
import { ParamContext } from '../../../../shared/service/param.context';
import { UserService } from '../../../../site-admin/services/user.service';
import { SampleListCreationComponent } from '../../../../shared/list-creation/sample-list-creation.component';
import { SampleList } from '../../../../shared/list-creation/model/sample-list';
import { User } from '../../../../shared/user/model/user.model';
import { DateHelperService } from '../../../../shared/service/date.helper.service';

@Component({
    selector: 'jhi-create-genotyping-samples-modal',
    templateUrl: './create-genotyping-samples-modal.component.html',
    styleUrl: './create-genotyping-samples-modal.component.scss'
})
export class CreateGenotypingSamplesModalComponent implements OnInit {

    @Input() studyId: number;
    @Input() datasetId: number;
    @Input() instanceIds: string[];

    users: any[];
    variables: ObservationVariable[] = [];
    dateSampling: NgbDate;
    selectedUser: User;
    variableSelected: any;
    listOwner: string;

    constructor(private activeModal: NgbActiveModal,
                private datasetService: DatasetService,
                private userService: UserService,
                private alertService: AlertService,
                private paramContext: ParamContext,
                private modalService: NgbModal,
                private principal: Principal,
                private dateHelperService: DateHelperService) { }

    ngOnInit(): void {
        this.datasetService.getVariables(this.studyId, this.datasetId, VariableTypeEnum.SELECTION_METHOD.valueOf()).toPromise().then((response)=> {
            this.variables = response.body;
            if (this.variables.length === 0) {
                this.alertService.error('study-editor.genotyping-samples.create-genotyping-samples-modal.no-selection-variables');
            } else {
                this.variableSelected = this.variables[0];
            }
        });

        this.userService.filterUsers(this.paramContext.cropName, this.paramContext.programUUID).toPromise().then(async (response) => {
            const currentUser = await this.principal.getCurrentlyLoggedInUser();
            this.users = response.body;

            this.users.forEach(user => {
                if (user.id === currentUser.id) {
                    this.selectedUser = user;
                    this.listOwner = user.firstName + ' ' + user.lastName;
                }
            });
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }

    disableSave() {
        return !this.variableSelected || !this.selectedUser || !this.dateSampling;
    }

    save() {

        const sampleList: SampleList = {
            createdBy: this.listOwner,
            samplingDate: this.dateHelperService.convertFormattedNgbDateToString(this.dateSampling, '-'),
            selectionVariableId: this.variableSelected.id,
            // instanceIds in request is actually instance number.
            instanceIds: this.instanceIds,
            takenBy: this.selectedUser.username,
            datasetId: this.datasetId,
            cropName: this.paramContext.cropName,
            programUUID: this.paramContext.programUUID,
            parentId: 0,
        };

        const modalRef = this.modalService.open(SampleListCreationComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.sampleList = sampleList;
        modalRef.result.then((result) => {
            this.activeModal.close(result);
        }, (reason) => {
            this.activeModal.dismiss();
        });
    }

}
